<template>
	<div class="newReview">
		<el-dialog
			:visible.sync="dialogVisible" :before-close="handleCloseNewReview" :close-on-click-modal="false" :append-to-body="false">
			<p class="title pl14">
				<i class="iconfont icon-xinjian mr8"></i>
				编辑标题
			</p>
			<div class="content contentEditTitle">
				<el-form class="reviewForm" ref="ruleFormFile" :model="ruleFormFile">
					<el-form-item label="标题" prop="title">
						<el-input v-model.trim="ruleFormFile.title" type="textarea"
                      :maxlength = 100
                      :autosize="{ minRows: 2, maxRows: 3}"></el-input>
					</el-form-item>
					<div class="formBtn tac">
						<a class="startReview hlh40 tac bdr3" @click="saveFun">保存</a>
						<a class="startReview hlh40 tac bdr3" @click="handleCloseNewReview">取消</a>
					</div>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			dialogVisible: false,//弹窗是否显示			
			ruleFormFile: { 
				title: "" ,
				id:""
			},
		};
	},
	created(){		
	},
	methods:{
		//弹窗显示
		childFun(title,id){
			this.ruleFormFile.title=title;
			this.ruleFormFile.id=id;
			this.dialogVisible = true; 
		},
		//弹窗关闭按钮
		handleCloseNewReview(){
			this.ruleFormFile.title="";
			this.ruleFormFile.id="";
			this.dialogVisible = false; 
		},		
		//保存
		saveFun(){
			if(this.ruleFormFile.title){
				this.axios.put('/japi/check/report_handle/',{id:this.ruleFormFile.id,title:this.ruleFormFile.title}).then(res => {
					if (res.data.code == 200) {
						console.log("编辑标题成功======");
						console.log(res);
						this.$message({
							message: "编辑标题成功",
							type: "success",
							duration: 3000
						});
						this.handleCloseNewReview();//弹窗消失
						this.$emit('parentFun');//调用父组件
					} else if(res.data.code == 500){
						this.$message({
							message: "编辑标题失败，请重新上传！",
							type: "warning",
							duration: 3000
						});
					}
					else{
						this.$message({
							message: res.data.msg,
							type: "warning",
							duration: 3000
						});
					}
				});
			}else{
				this.$message({
					message: "标题不能为空，请输入标题！",
					type: "warning",
					duration: 3000
				});
			}
		},
		
	}
};
</script>
<style lang="scss" scope>
@import "../../../assets/css/dialog.scss";//弹窗样式
</style>